<template>
  <div class="totop" @click="totop()" v-if="show">
    <!--<i class="van-icon iconfont icon-totop"></i>-->
  </div>
</template>

<script>
  export default {
    name: "totop",
    data () {
      return {
        show:false,
        fullHeight: document.documentElement.clientHeight,
      }
    },
    methods:{
      totop:function () {
        $('body,html').animate({scrollTop: 0},'slow');
      },
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if(scrollTop>this.fullHeight){
          this.show =true
        }
        if(scrollTop==0){
          this.show =false
        }
      },
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style lang="less" scoped>
.totop{
  display: inline-block;
  position: fixed;
  right: 0px;
  bottom: 90px;
  background: #fff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  background: url("/static/images/totop.png") no-repeat center;
  -webkit-background-size:100% 100%;
  background-size:100% 100%;
  z-index: 1000;
  .iconfont{
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/totop.vue